import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown } from 'react-feather';
import { toast } from 'react-toastify';

//actions
import { useAuth } from 'shared/state/auth/actions';
import { useAuthUser } from 'shared/state';
import { getUserInitials, getFormatedDate } from "shared/utils";

// Components
import { Dropdown } from 'react-bulma-components';
import { Thumbnail } from "shared/components/user";

// Styles
import styles from './TopNavBar.module.scss';

const TopNavBar = () => {
    const navigate = useNavigate();
    const { user } = useAuthUser();
    const { authLogout } = useAuth();
    const initials = user && getUserInitials(user.name, user.surname);
    const currentDate =  getFormatedDate();

    const DropdownLabel = () => {
        return <Thumbnail
            backgroundColor="#B3B5BD"
            image={ user && user.image }
            initials={ initials } />
    }

    const handleDropdownOnChange = (ev) => {
        switch(ev){
            case 'logout':
                handleLogout();
                break;
            case 'profile':
                navigate('/profile', { replace: true });
                break;
            default:
                return false;
        }
    }

    const handleLogout = () => {
        authLogout().then((response)=> {
            // logout returns message from server
            response && toast.info(response, {
                toastId: "auth_token",
                autoClose: 3000,
                position: toast.POSITION.TOP_CENTER
            });
        })
    };

    return (
        <header className={`navbar has-shadow ${ styles.topNav }`}>
            <div className="navbar-item">
                <p>
                    <span className={ styles.welcome }>Welcome { user && user.name }</span>
                    <small>{ currentDate }</small>
                </p>
            </div>
            <div className={ styles.actions }>
                <Dropdown
                    right
                    hoverable
                    onChange={ handleDropdownOnChange }
                    icon={<ChevronDown size={ 15 } strokeWidth={2} />}
                    label={<DropdownLabel />}>

                    <Dropdown.Item
                        className={ styles.link }
                        renderAs="a"
                        value="profile">
                            Profile
                    </Dropdown.Item>

                    <Dropdown.Divider />

                    <Dropdown.Item
                        className={ styles.link }
                        renderAs="a"
                        value="logout">
                            Logout
                    </Dropdown.Item>
                </Dropdown>
            </div>
        </header>
    );
}

export default TopNavBar;
